define('collections/Podio.Collections.Comments',['require','lib/backbone/Backbone.PodioCollection','models/Podio.Models.Comment'],function(require) {

  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');

  return PodioCollection.extend({

    url: '/comments',

    configure: function() {
      this.model = require('models/Podio.Models.Comment');
    },

    getFresh: function() {
      return this.filter(function(comment) {
        return comment.get('fresh') === true;
      });

    }

  });

});

